export default "__VITE_ASSET__c2df79e1__"